import { Injectable } from '@angular/core';
import { LocationService } from '@shared/shared/navigation/location.service';

@Injectable()
export class LocationServiceWeb extends LocationService {
  reloadPage(): void {
    window.location.reload();
  }
}
